import {SINGLETON_CLASS} from "@kta20-core/constants";
import {IModuleConfig} from "@kta20-core/interfaces/base-module";
import {IModuleConfigService} from "@kta20-core/interfaces/i-module-config-service";

export class ModuleConfigService implements IModuleConfigService {

    static get(): ModuleConfigService {
        if (!this.inst) this.inst = new ModuleConfigService();

        return this.inst;
    }

    private static inst:ModuleConfigService;
    
    _config = {};

    constructor() {
        if (ModuleConfigService.inst) throw new Error(SINGLETON_CLASS);
    }

    getConfig<T extends IModuleConfig>(key:string): T {
        return <T>this._config[key];
    }


    setConfig<T extends IModuleConfig>(moduleConfig: T, key:string) {
        this._config[key]=moduleConfig;
    }



}